import React, { Fragment, useMemo } from "react";

import { Preview } from "@creatomate/preview";
import { Loader } from "@culturehq/components";
import VttSection from "./VttSection";
import { isSubtitleText } from "../utils";
import AddSection from "./AddSection";

interface VttParserProps {
  preview: Preview;
}

const VttParser: React.FC<VttParserProps> = ({ preview }) => {
  const { elements } = preview.state || { elements: [] };

  const subtitleElements = useMemo(() => elements.filter(
    element => isSubtitleText(element.source.name)), [elements]
  );

  return (
    <div className="VTT-Container">
      {subtitleElements.length === 0 && (
        <div className="VTT-Container__Buttons">
          <AddSection preview={preview} />
        </div>
      )}
      {subtitleElements.map((subtitleElement, index) => (
        <VttSection
          index={index}
          key={subtitleElement.source.id}
          preview={preview}
          subtitleElement={subtitleElement}
        />
      ))}
    </div>
  );
};

export default VttParser;
